import { createSlice } from '@reduxjs/toolkit';

const instantSlice = createSlice({
  name: 'instant',
  initialState: {
    employeeVo: {},
    isCheckPwSuccess: null,
    isUpdatePwSuccess: null,
    isCreateAccount: false,
    svcType: '',
  },
  reducers: {
    // 아이디 중복 체크
    checkPassword: state => {
      state.isCheckPwSuccess = null;
    },
    checkPasswordSuccess: (state, { payload }) => {
      state.isCheckPwSuccess = payload;
    },
    checkPasswordFail: state => {
      state.isCheckPwSuccess = false;
    },
    updateEmployee: state => {
      state.isUpdateEmployee = false;
    },
    updateEmployeeSuccess: (state, { payload }) => {
      state.isCreateAccount = payload;
    },
    updateEmployeeFail: state => {
      state.isCreateAccount = false;
    },
    getLoginUser: state => {
      state.employeeVo = {};
    },
    getLoginUserSuccess: (state, { payload }) => {
      state.employeeVo = payload;
      state.svcType = payload.serviceCdList;
    },
  },
});

export const {
  updateEmployee,
  updateEmployeeSuccess,
  updateEmployeeFail,
  checkPassword,
  checkPasswordFail,
  checkPasswordSuccess,
  getLoginUser,
  getLoginUserSuccess,
} = instantSlice.actions;
export default instantSlice.reducer;
